var loadjs = (function () {})();

(function ($, Drupal) {
  'use strict';

  // sets the cache setting to TRUE
  $.ajaxSetup({
    cache: true
  });

  Drupal.behaviors.mainScripts = {
    attach: function (context) {

      // newsletter country dropdown style change when selected
      var dropdown = $('.webform-submission-newsletter-signup-form .form-item-country-country select');
      $(dropdown).on('change', function(e) {
        $(dropdown).addClass('changed');
      });
    }
  };

  // Commenting instead of deleting juuuuust in case - as per TTB100-515
  // Drupal.behaviors.AnalyticsScript = {
  //   attach: function (context) {

  //     $( window ).on('load', function() {
  //       setTimeout(function(){
  //         getAnalyticsScript();
  //       }, 10000);
  //     });

  //   }
  // };

  // function getAnalyticsScript() {
  //   $.getScript( "https://cdn.evgnet.com/beacon/turtlebayresort/engage/scripts/evergage.min.js" )
  //     .then(function( script, textStatus ) {
  //       // console.log( textStatus + ' Loaded evergage script' );
  //     })
  //     .fail(function( jqxhr, settings, exception ) {
  //       /// $( "div.log" ).text( "Triggered ajaxError handler." );
  //   });
  // }

  // Drupal.behaviors.GTMSourceScript = {
  //   attach: function (context) {

  //   $( window ).once().on('load', function() {
  //       setTimeout(function(){
  //           // gtm js
  //           (function (d, id) {
  //             var host_url = location.protocol + "//" + location.host;
  //             var t, el = d.scripts[d.scripts.length - 1].previousElementSibling;
  //             if (el) el.dataset.initTimestamp = (new Date()).getTime();
  //             if (d.getElementById(id)) return;
  //             t = d.createElement('script');
  //             t.src = host_url + "/themes/custom/turtlebayresort/js/gtm-script.js";
  //             t.id = id;
  //             (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(t);
  //         }(document, 'gtm-js'));
  //       }, 10000);
  //   });
  //   }
  // };

  // Vimeo JS play and pause button
  // vimeo player - hero
  $('.video__controls--play, .video__controls--pause').on('click', function() {
    $('.video__controls button').toggleClass('hide');

    // For ADA tabbing/entering purposes. The below if chain makes sure that the next focused element after an enter press is the opposite button
    // For some reason, without the below if checks, after an enter press, the next focus element is the <body> tag :/
    if( $(this).hasClass("video__controls--pause") ) {
      $(this).prev().focus();
    }
    if( $(this).hasClass("video__controls--play") ) {
      $(this).next().focus();
    }
  });

  if($('.vimeo__media .video__wrapper').length) {
    var iframe = $('.vimeo__media iframe')[0]; // TOdo make it not only grab the first one

    if(Vimeo) {
      var player = new Vimeo.Player(iframe);

      // bind events
      var playButton = $(".video__controls--play")[0];
      playButton.addEventListener("click", function () {
        player.play();
      });

      var pauseButton = $(".video__controls--pause")[0];
      pauseButton.addEventListener("click", function () {
        player.pause();
      });

      // responsive behaviour: play video if using a desktop device
      // if ($(window).width() > 1024) {
      //   player.play();
      // }

      // responsive behaviour: check screen size on resize and play/pause video accordingly
      // window.addEventListener('resize', function () {
      //   if ($(window).width() > 1024) {
      //     player.play();
      //   } else {
      //     player.pause();
      //   }
      // });

    }

  }

}(jQuery, Drupal));

(function($, Drupal) {


  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    var extraScreen = 400; // THe Iframe is bigger than the parent page so its still loading

    return (
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth &&
      rect.bottom > 0 - extraScreen &&
      rect.right > 0
    );
  }

  class VimeoAutoPause {
    constructor(iframe) {
      this.type = "vimeo";
      this.iframe = iframe;
      this.vim = new Vimeo.Player(iframe);
      this.autoPaused = false;
    }

    ready(callback){
      var self = this;

      self.setup();
      callback();

    }

    setup() {
      var self = this;
      this.iframe._autoPause = this; // Set the object in the dom so it can be grabbed later
      this.vim.on('timeupdate', function(){
        if(!document.hasFocus() || !isInViewport(this.iframe)){
          self.pause();
        }
      });

      window.addEventListener('focus', function() {
        if( isInViewport(self.iframe)) {
          self.play();
        }
      });
    }

    play() {
      if(this.autoPaused) {
        this.vim.play();
        this.autoPaused=false;
      }
    }

    pause() {
      var self = this;
      this.vim.getPaused().then(function (paused) {
        if(!paused) {
          self.vim.pause();
          self.autoPaused = true;
        }
      });
    }
  }

  Drupal.behaviors.autoPauseVideo = {
    initialized: false,

    attach: function(contenxt, settings){
      if(!this.initialized) {
        this.initialized = true;
        this.init(contenxt, settings);
      }
    },

    init: function(contenxt, settings){
      var self = this;
      if (!!window.IntersectionObserver){
        let iframes = document.querySelectorAll("iframe");
        var players = [];

        iframes.forEach(function (iframe){
          var player;
          if(iframe.src.match(/player.vimeo\.com/)){
            player = new VimeoAutoPause(iframe);
          }

          if(player) {
            players.push(player);
            player.ready(function(){
              Interobserver.observe(player.iframe);
            });
          }
        });

        let Interobserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(entry => {

            var player = entry.target._autoPause;
            if(!entry.isIntersecting){
                player.pause();
              }
              else if(player.autoPaused) {
                player.play();
              }
            });
          }, {threshold: 0});

      }
    },
  };

}(jQuery, Drupal));